import { Briefcase, GraduationCap, Handshake, Wrench, HeartHandshake } from "lucide-react";
import { motion } from "framer-motion";
import { SectionHeading } from "../site/SectionHeading";

export const ECOSYSTEM_CARDS = [
  { Icon: Briefcase, title: "Business & Investments", text: "Access business opportunities, investment opportunities, scalable ventures, and strategic partnerships." },
  { Icon: GraduationCap, title: "Education & Development", text: "Masterclasses, mentorship, training, leadership development, and business education." },
  { Icon: Handshake, title: "Collaboration & Networking", text: "Connect with entrepreneurs, investors, professionals, founders, and business leaders." },
  { Icon: Wrench, title: "Resources & Tools", text: "Access exclusive technology, systems, professional services, business resources, and MST-supported tools." },
  { Icon: HeartHandshake, title: "Community Impact", text: "Create businesses, jobs, opportunities, and lasting economic impact in the communities MST serves." },
];

export const EcosystemCard = ({ Icon, title, text, index }) => (
  <motion.div
    data-testid={`ecosystem-card-${index}`}
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ y: -6 }}
    className="relative rounded-2xl border border-[#009BFF]/35 bg-gradient-to-b from-[#0A3055] via-[#062541] to-[#041525] p-7 flex flex-col h-full hover:shadow-[0_0_30px_rgba(0,196,244,0.18)] hover:border-[#00C4F4]/60 transition-[box-shadow,border-color] duration-300"
  >
    <div className="w-12 h-12 rounded-xl bg-[#009BFF]/15 border border-[#00C4F4]/40 flex items-center justify-center">
      <Icon size={22} strokeWidth={1.5} className="text-[#00C4F4]" />
    </div>
    <h3 className="mt-6 text-base font-extrabold text-white leading-snug" style={{ fontFamily: "var(--font-heading)" }}>
      {title}
    </h3>
    <p className="mt-3 text-sm text-[#B7C0CC] leading-relaxed">{text}</p>
  </motion.div>
);

export const EcosystemSection = () => (
  <section data-testid="ecosystem-section" className="relative bg-[#041525] py-24 lg:py-32 overflow-hidden">
    <div className="absolute inset-0 mst-dot-pattern opacity-30" />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
      <SectionHeading chapter="02" center light label="The MST Ecosystem" title={<>Multiple Streams. Endless Opportunities.</>} />
      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
        {ECOSYSTEM_CARDS.map((c, i) => (
          <EcosystemCard key={c.title} {...c} index={i} />
        ))}
      </div>
    </div>
  </section>
);
